import { render, staticRenderFns } from "./Kusama.vue?vue&type=template&id=fb6fe29c&scoped=true&"
import script from "./Kusama.vue?vue&type=script&lang=js&"
export * from "./Kusama.vue?vue&type=script&lang=js&"
import style0 from "./Kusama.vue?vue&type=style&index=0&id=fb6fe29c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6fe29c",
  null
  
)

export default component.exports